import { Link } from "react-router-dom";
import { SkedMark } from "@/components/SkedMark";
import { usePageMeta } from "@/hooks/usePageMeta";

export function NotFoundPage() {
  usePageMeta({ title: "Page not found · Traffic Snapshot" });
  return (
    <div className="flex min-h-dvh flex-col bg-white text-ink antialiased">
      <header className="px-8 pt-8">
        <div className="mx-auto flex max-w-[1200px] items-center">
          <Link to="/" className="flex items-center gap-3 text-ink no-underline">
            <SkedMark className="h-10 w-10" aria-hidden="true" />
            <span className="leading-[1.05]">
              <span className="block text-xs font-bold tracking-tight text-neutral-500">
                Sked Social
              </span>
              <span className="block font-display text-lg font-[900] tracking-tight text-ink">
                Traffic Snapshot
              </span>
            </span>
          </Link>
        </div>
      </header>

      <main className="flex flex-1 items-center justify-center px-6 py-16">
        <div className="text-center">
          <p className="font-display text-[140px] font-[900] leading-none tracking-[-0.04em] text-ink tabular-nums md:text-[180px]">
            404
          </p>
          <p className="mx-auto mt-4 max-w-[30ch] font-serif italic text-[18px] font-medium leading-[1.4] text-purple-700">
            That page isn't part of the Snapshot yet.
          </p>
          <p className="mx-auto mt-3 max-w-[42ch] text-[15px] leading-[1.55] text-neutral-600">
            Try the landing page, audit your UTMs without signing in, or connect GA4 to open the
            app.
          </p>
          <div className="mt-8 flex flex-wrap items-center justify-center gap-5">
            <Link to="/" className="ts-cta ts-cta-lg">
              Back to landing <span className="ts-cta-arrow">→</span>
            </Link>
            <Link to="/utm-health-check" className="ts-link">
              Audit UTMs <span className="ts-link-arrow">→</span>
            </Link>
          </div>
        </div>
      </main>

      <footer className="px-8 pb-10">
        <div className="mx-auto flex max-w-[1200px] items-center gap-3 text-[13px] text-neutral-500">
          <span>
            <b className="font-bold text-ink">Traffic Snapshot</b> · a free report from Sked Social
            · <i className="font-serif italic font-medium text-purple-700">social-first</i>{" "}
            analytics, built for marketers.
          </span>
        </div>
      </footer>
    </div>
  );
}
